<template>
  <div>
    <Loading v-if="isLoadingPage"></Loading>
    <div class="checkout" v-else>
      <div class="checkout__main">
        <h4 class="checkout__title">{{ getTranslatedText("Checkout") }}</h4>
        <div class="checkout__header" v-if="!$store.state.isScreenMobile">
          <p class="text type"></p>
          <p class="text date">{{ getTranslatedText("Draw date") }}</p>
          <p class="text game">{{ getTranslatedText("Game name") }}</p>
          <p class="text bet">{{ getTranslatedText("Bet type") }}</p>
          <p class="text numbers">{{ getTranslatedText("Numbers selected") }}</p>
          <p class="text cost">{{ getTranslatedText("Cost") }}</p>
          <p class="clear"></p>
        </div>
        <div
          v-if="$store.state.dataCheckout.length === 0"
          class="checkout__empty"
        >
          {{ getTranslatedText("your checkout is empty") }}
        </div>
        <div
          class="checkout__content-main"
          v-for="(item, index) in dataCheckout"
          :key="index"
        >
          <div v-if="item.typeGame === 1">
            <div
              class="checkout__content"
              :class="{ checkout_error: item.itemErrorCutoff }"
            >
              <p class="text type">{{ getTranslatedText("Single bet") }}</p>
              <p class="text date">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("Draw date")
                }}</span
                >{{ $helpers.formatDateTime(item.draw_date) }}
              </p>
              <p class="text game">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("Game name")
                }}</span
                >{{ item.draw_name }}
              </p>
              <p class="text bet">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("Bet type")
                }}</span
                >{{ item.regualName }}
              </p>
              <div class="text numbers">
                <template v-if="item.selected_numbers">
                  <span v-if="$store.state.isScreenMobile">{{
                    getTranslatedText("Numbers selected")
                  }}</span>
                  <div
                    class="number"
                    v-for="(data, inx) in item.selected_numbers"
                    :key="inx"
                  >
                    {{ data }}
                  </div>
                </template>
                <template v-else>
                  <span v-if="$store.state.isScreenMobile">{{
                    getTranslatedText("Numbers selected")
                  }}</span>
                  <div class="type_select">{{ item?.selected_game?.name }}</div>
                </template>
              </div>
              <p class="text cost">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("Cost")
                }}</span
                >{{ renderPrice(item.betAmount) }}
              </p>
              <div class="clear" @click="handleClearItems(item.typeGame, index)">
                <img src="~ThemePath/img/checkout/remove.png" />
              </div>
            </div>
            <hr v-if="$store.state.isScreenMobile" />
          </div>
          <div
            class="multibet"
            v-if="item.typeGame === 2"
            :class="{ checkout_error: item.itemErrorCutoff }"
          >
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="text type">
                    <span>{{ getTranslatedText("Multibet") }}</span>
                  </p>
                  <p v-if="!$store.state.isScreenMobile" class="empty_area"></p>
                  <p v-if="!$store.state.isScreenMobile" class="text cost">
                    <span v-if="$store.state.isScreenMobile">{{
                      getTranslatedText("Cost")
                    }}</span
                    ><span>{{ renderPrice(item.betAmount) }}</span>
                  </p>
                  <div class="clear" @click="handleClearItems(1, index)">
                    <img src="~ThemePath/img/checkout/remove.png" />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div
                    class="checkout__block"
                    v-for="(value, i) in item.data"
                    :key="i"
                  >
                    <div
                      class="checkout__content"
                      :class="{ checkout_error: value.itemErrorCutoff }"
                    >
                      <p class="text type"></p>
                      <p class="text date">
                        <span v-if="$store.state.isScreenMobile">{{
                          getTranslatedText("Draw date")
                        }}</span
                        >{{ $helpers.formatDateTime(value.draw_date) }}
                      </p>
                      <p class="text game">
                        <span v-if="$store.state.isScreenMobile">{{
                          getTranslatedText("Game name")
                        }}</span
                        >{{ value.draw_name }}
                      </p>
                      <p class="text bet">
                        <span v-if="$store.state.isScreenMobile">{{
                          getTranslatedText("Bet type")
                        }}</span
                        >{{ value.regualName }}
                      </p>
                      <div class="text numbers">
                        <template v-if="value.selected_numbers">
                          <span v-if="$store.state.isScreenMobile">{{
                            getTranslatedText("Numbers selected")
                          }}</span>
                          <div
                            class="number"
                            v-for="(data, inx) in value.selected_numbers"
                            :key="inx"
                          >
                            {{ data }}
                          </div>
                        </template>
                        <template v-else>
                          <span v-if="$store.state.isScreenMobile">{{
                            getTranslatedText("Numbers selected")
                          }}</span>
                          <div class="type_select">{{ value?.selected_game?.name }}</div>
                        </template>
                      </div>
                      <p class="text cost">
                        <span v-if="$store.state.isScreenMobile">{{
                          getTranslatedText("Cost")
                        }}</span
                        ><span v-if="$store.state.isScreenMobile">{{
                          renderPrice(item.betAmount)
                        }}</span>
                      </p>
                      <div
                        class="clear"
                        @click="handleClearItems(item.typeGame, index, i)"
                      >
                        <img src="~ThemePath/img/checkout/remove.png" />
                      </div>
                    </div>
                    <div v-if="item.typeGame === 1">
                      <hr v-if="$store.state.isScreenMobile" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div class="checkout__bottom">
        <div class="checkout__total">
          <div v-if="$store.state.dataCheckout.length > 0">
            <p class="total">
              {{ getTranslatedText("Total Cost: ") + renderPrice(totalCost) }}
            </p>
            <p class="transaction">
              {{
                getTranslatedText("No of Transactions: ") +
                $store.state.dataCheckout.length
              }}
            </p>
          </div>
        </div>
        <div class="checkout__box-btn">
          <ButtonCommon
            text="Clear All"
            class-name="checkout__box-btn__item clear-btn"
            :isNoHover="true"
            @action-button="handleClearAll()"
            :isDisable="dataCheckout.length === 0"
          />
          <ButtonCommon
            text="Submit"
            class-name="checkout__box-btn__item submit-btn"
            :isNoHover="true"
            @action-button="handleSubmit()"
            :isDisable="dataCheckout.length === 0"
          />
          <ButtonCommon
            text="cancel"
            class-name="checkout__box-btn__item cancel-btn"
            :isNoHover="true"
            @action-button="onCancel()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import printMixins from "@/mixins/print/print-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import { formatPrice } from "@/utils/utils";
import ButtonCommon from "@/components/common/button";
import EventBus from "@/utils/EventBus";
import Transaction from "@/services/transaction.service";
import Loading from "@/components/common/loading";
import GamesService from "@/services/games.service";
const CURRENCY_SYMBOL = process.env.VUE_APP_CURRENCY_SYMBOL;
const GAMES_SLUG = process.env.VUE_APP_ENABLE_GAMES_SLUG;
const TIME_ZONE = process.env.VUE_APP_TIME_ZONE;

export default {
  mixins: [languageMixins, errorDeviceMinxins, printMixins, configGameMinxins],
  components: { ButtonCommon, Loading },
  data() {
    return {
      listCheckout: [],
      dataSubmit: [],
      CURRENCY: this.$store.state.configAccount?.settings.CURRENCY_SYMBOL ? this.$store.state.configAccount?.settings.CURRENCY_SYMBOL : CURRENCY_SYMBOL,
      isLoadingPage: false,
      dataGames:'',
    };
  },
  created() {
    this.fetchDataGames();
    EventBus.$on("on-clear-all", () => this.onClearAll());
    EventBus.$on("on-remove-item", (param) => this.onRemoveItem(param));
    EventBus.$on("on-submit", () => this.onSubmit());
    EventBus.$on("go-home", () => {
      this.$router.push("/");
    });
  },
  destroyed() {
    EventBus.$off("on-clear-all");
    EventBus.$off("on-remove-item");
    EventBus.$off("on-submit");
    EventBus.$off("go-home");
  },
  computed: {
    dataCheckout() {
      return this.$store.state.dataCheckout;
    },
    totalCost() {
      return this.dataCheckout.reduce(
        (total, item) => total + item.betAmount,
        0
      );
    }
  },
  methods: {
    async fetchDataGames() {
      try {
        this.isLoadingPage = true;
        const res = await GamesService.getListGame();
        if (res.status === "success") {
          this.dataGames = res.data;
        } else {
          console.log(res)
        }
        this.isLoadingPage = false;

        this.$store.dispatch("fetchDataConfig").then(()=>{
          this.checkConfigGame();
          // this.checkDateCheckout();
        }).catch(()=>{
          this.checkConfigGame();
          // this.checkDateCheckout();
        })
      } catch (error) {
        console.log(error);
        this.isLoadingPage = false;
        this.checkConfigGame();
        // this.checkDateCheckout();
      }
    },
    handleClearAll() {
      const param = {
        title: "CONFIRM",
        status: "confirm",
        description: "Do you want to delete all checkout ?",
        nameFunction: "on-clear-all",
      };
      if (this.dataCheckout.length) {
        EventBus.$emit("on-show-notications", param);
      }
    },
    handleClearItems(typeGame, index, idItem) {
      const param = {
        title: "CONFIRM",
        status: "confirm",
        description: "Do you want to delete this item ?",
        nameFunction: "on-remove-item",
        paramFunction: {
          typeGame,
          index,
          idItem,
        },
      };
      EventBus.$emit("on-show-notications", param);
      event.stopPropagation();
    },
    handleSubmit() {
      let param;
      if(!this.checkConfigGame()){
        param = {
          status: "error",
          title: "the game you selected has been disabled",
          description:"Please Try Again",
        };
      }
      // else if (!this.checkDateCheckout()) {
      //   param = {
      //     status: "error",
      //     description:
      //       "The date you selected has expired, please choose another date",
      //   };
      // }
      else {
        param = {
          title: "Confirm Transaction",
          titleLoading: "Transaction status",
          status: "confirm",
          description: "Total Amount",
          amount: `${this.CURRENCY} ${this.renderPrice(this.totalCost)}`,
          nameFunction: "on-submit",
          confirmLoading: true,
        };
      }
      EventBus.$emit("on-show-notications", param);
    },
    onRemoveItem(param) {
      this.$store.dispatch("clearItemCheckout", param);
    },
    onClearAll() {
      this.$store.dispatch("clearAllCheckout");
    },
    // checkDateCheckout() {
      // const currentDate = this.$helpers.changeTimeZone(new Date(),TIME_ZONE);
      // let specificDate;
      // let resultCheck = true;
      // this.dataCheckout.forEach((item) => {
      //   if (item.typeGame === 1) {
          // specificDate = this.$helpers.changeTimeZone(new Date(item.cutoff),TIME_ZONE);
          // if (specificDate < currentDate) {
          //   item.itemErrorCutoff = true;
          //   resultCheck = false;
          // }
        // } else if (item.typeGame === 2) {
          // item.data.forEach((ob) => {
          //   specificDate = this.$helpers.changeTimeZone(new Date(ob.cutoff),TIME_ZONE);
          //   if (specificDate < currentDate) {
          //     ob.itemErrorCutoff = true;
          //     resultCheck = false;
          //   }
          // });
    //       item.itemErrorCutoff = item.data.some(
    //         (ob) => ob.itemErrorCutoff === true
    //       );
    //     }
    //   });
    //   return resultCheck;
    // },
    checkConfigGame() {
      let resultCheck = true;
      const conditions = this.configGame.map((item) => ({ slug: item.slug, enabled: item.enabled }))
      for (const item of this.dataCheckout) {
          if (item.typeGame === 1 || item.typeGame === 2) {
            const checkCondition = (obj) => {
              return conditions.some(condition => condition.slug === obj?.game?.slug && condition.enabled);
            };

            if (item.typeGame === 1) {
              item.itemErrorCutoff = !checkCondition(item);
              this.dataGames.forEach((e) => {
                if (item?.game?.slug === e?.game?.slug) {
                  const hasMarket = e.markets?.some((market) => market.market_slug === item.market_slug);
                  if(!hasMarket) item.itemErrorCutoff = true;
                }
              })
            } else if (item.typeGame === 2) {
              for (const ob of item.data) {
                ob.itemErrorCutoff = !checkCondition(ob);
                this.dataGames.forEach((e) => {
                  if (ob?.game?.slug === e?.game?.slug) {
                    const hasMarket = e.markets?.some((market) => market.market_slug === ob.market_slug);
                    if(!hasMarket) ob.itemErrorCutoff = true;
                  }
                })
              }
              item.itemErrorCutoff = item.data.some((ob) => ob.itemErrorCutoff === true);
            }
          }
      }
      resultCheck = !this.dataCheckout.some((item) => item.itemErrorCutoff === true);
      return resultCheck;
    },
    async onSubmit() {
      try {
        const dataSubmit = this.dataCheckout.reduce(
          (accumulator, item) => {
            if (item.typeGame === 1) {
              const singleBetEntry = {
                wager: item.betAmount,
                game: item.game.slug,
                odds: Number(item.odds),
                market: item.market_slug,
                selection: item.selected_numbers ? [[...item.selected_numbers]] : [item?.selected_game?.key],
                eventId: item.event_id,
              };
              accumulator.singleBet.entries.push(singleBetEntry);
            } else if (item.typeGame === 2) {
              const multiBetEntries = item.data.map((data) => ({
                game: data.game.slug,
                odds: Number(data.odds),
                market: data.market_slug,
                selection: data.selected_numbers ? [[...data.selected_numbers]] : [data?.selected_game?.key],
                eventId: data.event_id,
              }));
              const multiBetEntry = {
                wager: item.betAmount,
                entries: multiBetEntries,
              };
              accumulator.multiBet.entries.push(multiBetEntry);
            }
            return accumulator;
          },
          {
            singleBet: { type: "singlebet", entries: [] },
            multiBet: { type: "multibet", entries: [] },
          }
        );

        const dataSubmitArray = [];
        if (dataSubmit.singleBet.entries.length > 0) {
          dataSubmitArray.push(dataSubmit.singleBet);
        }
        if (dataSubmit.multiBet.entries.length > 0) {
          dataSubmitArray.push(dataSubmit.multiBet);
        }
        const res = await Transaction.apiSubmitTransaction(dataSubmitArray);
        const param = {
          title: res.message,
          status: res.status,
          loadingTransaction: false,
        };
        if (res.status === "success") {
          this.onClearAll();
          param.nameFunctionClose = "go-home";

          // https://bitville.atlassian.net/browse/DEV01-5707
          // set base64 string to first item only to limit payload size
          let printData = await this.prepareLogoAsSingleObject(res?.data?.printData);
          parent.postMessage(
            { command: "print-ticket", data: printData, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont },
            "*"
          );
        } else {
          console.log(res.data.errors);
          param.title = res.data?.errors
          ? res.data.errors.map(item => item.message).join(', ')
          : res.message;
        }
        EventBus.$emit("on-show-notications", param);
        this.checkErrorDevice(this.$router, res)
      } catch (error) {
        const param = {
          title: error.message,
          status: "error",
          loadingTransaction: false,
        };
        param.title = error.data?.errors
          ? error.data.errors.map(item => item.message).join(', ')
          : error.message;
        EventBus.$emit("on-show-notications", param);
        this.checkErrorDevice(this.$router, error)
        console.log(error);
      }
    },
    onCancel() {
      this.$router.go(-1);
    },
    renderPrice(price) {
      return formatPrice(price);
    },
  },
  watch: {
    dataCheckout() {
      this.checkConfigGame();
      // this.checkDateCheckout();
    },
    deep: true,
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/checkout-info/_index.scss";
</style>
